module.exports = __webpack_public_path__ + "static/media/olx-alpha.1c326cc8.png";